export default __webpack_public_path__ + "static/jobbox-banner-abc71e58399aea05afa29e57b5ee617e.webp";